/**
 * Devuelve un deep clone del viewField.
 *
 * > El viewField tiene la propiedad `parent` que es una referencia al padre.
 * > Eso da problemas a la hora de clonear porque da un error "RangeError: Maximum call stack size exceeded"
 * > Este metodo lo toma en cuenta y no clonea esa propiedad `parent`, la re-crea.
 *
 * > Nota que en el primer nivel `cloned.parent` === `viewField.parent`
 *
 * @param {Object} viewField
 * @returns {Object}
 */

export function cloneViewField(viewField, options = {}) {
  const { parent: withParent, properties: withProperties } = Object.assign({ parent: true, properties: true }, options);
  return clone(viewField, viewField.parent);

  function clone(o, parent) {
    if (typeof o !== 'object' || o === null) {
      // Nota: typeof null, [], {} === 'object'
      return o;
    }

    if (Array.isArray(o)) {
      return o.reduce((acc, cur) => [...acc, clone(cur, o)], []);
    }

    if (o instanceof Date) {
      return new Date(o.toISOString());
    }

    return Object.keys(o).reduce((acc, cur) => {
      if (cur === 'parent') {
        if (withParent) {
          acc[cur] = parent;
        }
      } else if (cur === 'properties') {
        if (withProperties) {
          acc[cur] = clone(o[cur], o);
        }
      } else {
        acc[cur] = clone(o[cur], o);
      }

      return acc;
    }, {});
  }
}
